<h2 mat-dialog-title>Confirm PARCS Sync</h2>
<mat-dialog-content>
  <p>Clicking confirm below will sync <strong>{{ numberOfParkersToSync }}</strong> selected Parkers to PARCS.  </p>
  <p>Note that during this sync, the following spACE AR Parker data will update any existing matching PARCS profiles.</p>
  <ul>
    <li>Last Name</li>
    <li>First Name</li>
    <li>Company Name</li>
    <li>Card Number</li>
    <li>Vehicle Information</li>
    <li>Email Address</li>
    <li>Start Date</li>
    <li>End Date</li>
    
</ul>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-button mat-dialog-close="true" cdkFocusInitial>Confirm</button>
</mat-dialog-actions>
